export default function hasRole(userRoles = [], ...roles) {
  const cleanUserRoles = userRoles === null ? [] : userRoles;
  return roles.length
    ? roles.some(role => cleanUserRoles.includes(role))
    : true;
}
